module.exports = __webpack_public_path__ + "static/media/comming-soon.9f02c3d9.jpg";